import React from 'react';

const TextError = (props: any) => {
  const { children } = props;
  return <div className="error">{children}</div>;
};

export default TextError;
